import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import LookupGeneric from "./lookupGeneric";
import AchievementTypeService from "../../src/Services/AchievementType.service";
const AchievementTypeLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        defaultIds: props.defaultIds,
        fetchItemsById: (ids) => {
            return AchievementTypeService.findByIds(ids);
        },
        fetchOptions: (search) => {
            return AchievementTypeService.searchAll(search);
        },
        optionRenderer: function optionRenderer(achievementType) {
            return _jsx("span", { children: achievementType.name });
        },
    });
};
export default AchievementTypeLookup;
